// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__qSZ_q","inputWrap":"styles_inputWrap__wEJRk","input":"styles_input__2RPGp"};